import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, HStack, Image, Text } from "@chakra-ui/react";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { IMG_URL } from "./common/Constant";
const PubVibesSection = ({ vibes, pubColors, pubData }) => {
    const navigate = useNavigate();
    const videoRefs = useRef([]);
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const video = entry.target;
                if (entry.isIntersecting) {
                    video.play().catch(() => {
                        // Silently catch play interruption errors
                    });
                }
                else {
                    video.pause();
                }
            });
        }, { threshold: 0.5 });
        videoRefs.current.forEach((video) => {
            if (video)
                observer.observe(video);
        });
        return () => {
            observer.disconnect();
            // Pause all videos on cleanup
            videoRefs.current.forEach((video) => {
                if (video) {
                    video.pause();
                }
            });
        };
    }, [vibes]);
    const mediaType = (url) => {
        var _a;
        if (!url) {
            return false;
        }
        const extension = (_a = url.split(".").pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        if (extension) {
            if (["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(extension)) {
                return false;
            }
            else if (["mp4", "mov", "webm", "avi"].includes(extension)) {
                return true;
            }
        }
        return false;
    };
    const handleVibeClick = (index) => {
        // Pause all videos before navigation
        videoRefs.current.forEach((video) => {
            if (video) {
                video.pause();
            }
        });
        navigate(`/vibes`, {
            state: {
                data: {
                    vibes: {
                        vibes: vibes,
                        defaultIdx: index,
                    },
                    ...(pubData && {
                        itemId: pubData.itemId,
                        name: pubData.name,
                        pubType: pubData.pubType,
                        shortAddress: pubData.shortAddress,
                    }),
                },
            },
        });
    };
    return (_jsx(Box, { width: "100%", pb: [0, 0, 2], children: _jsxs(Box, { minHeight: "350px", h: "100%", borderTopLeftRadius: "20px", borderBottomLeftRadius: "20px", display: "flex", flexDirection: "column", p: 3, pr: 0, children: [_jsxs(Flex, { width: "100%", height: "65px", justifyContent: "center", children: [_jsx(Image, { src: `${IMG_URL}/icons/duck.png`, alt: "Duck Icon", height: "100%", objectFit: "contain", transform: "translateY(8px)" }), _jsxs(Box, { ml: 2, children: [_jsx(Text, { fontSize: "3xl", color: pubColors.text, fontStyle: "italic", fontFamily: "'Dancing Script', cursive", children: "Chillout moments" }), _jsx(Text, { fontSize: "12px", color: pubColors.text, children: "Where every moment feels right." })] })] }), _jsxs(HStack, { height: "100%", mx: "auto", mt: [5, 5, 5, 10], overflowX: "auto", gap: 4, children: [vibes === null || vibes === void 0 ? void 0 : vibes.map((src, index) => {
                            const isVideo = mediaType(src);
                            return isVideo ? (_jsx("video", { src: src, muted: true, loop: true, playsInline: true, ref: (el) => {
                                    if (el)
                                        videoRefs.current[index] = el;
                                }, onClick: () => handleVibeClick(index), style: {
                                    borderRadius: "8px",
                                    width: "160px",
                                    height: "230px",
                                    objectFit: "cover",
                                    border: "2px solid white",
                                    boxShadow: "0 0 2px rgba(255, 255, 255, 0.2)",
                                    cursor: "pointer",
                                } }, index)) : (_jsx(Image, { src: src || `${IMG_URL}/background/videoFrame.png`, alt: `Media ${index + 1}`, borderRadius: 20, width: ["160px", "160px", "160px", "225px"], height: ["230px", "230px", "230px", "350px"], objectFit: "cover", boxShadow: "0 0 2px rgba(255, 255, 255, 0.2)", cursor: "pointer", _hover: { opacity: 0.9 }, transition: "opacity 0.2s", onClick: () => handleVibeClick(index) }, index));
                        }), _jsx(Box, { width: 4 })] })] }) }));
};
export default PubVibesSection;
